import useBulkActions from "@saleor/hooks/useBulkActions";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import React from "react";
import { useIntl } from "react-intl";

import ComboDetails, {
  ComboFormData
} from "../components/ComboDetails/ComboDetails";
import { useComboCreateMutation } from "../mutations";
import { comboListPath, comboUrl, ComboUrlQueryParams } from "../urls";

interface ComboDetailsProps {
  params: ComboUrlQueryParams;
}
const Combo: React.FC<ComboDetailsProps> = ({ params }) => {
  const navigate = useNavigator();
  const intl = useIntl();
  const notify = useNotifier();
  const { isSelected, listElements, toggle, toggleAll } = useBulkActions(
    params.ids
  );
  const [comboCreate, comboCreateOpts] = useComboCreateMutation({
    onCompleted: data => {
      if (data.comboCreate.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "General Information Update Success"
          })
        });
        navigate(comboUrl(data.comboCreate.combo.id));
      }
    }
  });

  const handleSubmit = async (data: ComboFormData) => {
    const result = await comboCreate({
      variables: {
        input: {
          name: data.name,
          totalPrice: data.totalPrice,
          labelText: data.labelText,
          labelLink: data.labelLink,
          enable: data.enable
        }
      }
    });
    return result.data.comboCreate.errors;
  };

  return (
    <>
      <ComboDetails
        combo={null}
        disabled={comboCreateOpts.loading}
        onNextPage={null}
        onPreviousPage={null}
        toggle={toggle}
        toggleAll={toggleAll}
        isChecked={isSelected}
        selected={listElements.length}
        onSubmit={handleSubmit}
        activeTab={params.activeTab}
        onBack={() => navigate(comboListPath)}
        saveButtonBarState={comboCreateOpts.status}
        variantListToolbar={null}
      />
    </>
  );
};
export default Combo;
